import { endOfToday, startOfToday } from 'date-fns';
import { FilterControl } from '../../components/FilterTagsButton/Filters';
import {
  FilterableFields,
  FilterFormConfig,
} from '../../components/FilterTagsButton/types';
import { useUrlState } from '../../hooks/useUrlState';

const DEFAULT_FILTER_VALUES = {
  created_at_from: startOfToday(),
  created_at_to: endOfToday(),
};

const DATE_FIELDS: FilterableFields[] = [
  'created_at_from',
  'created_at_to',
  'due_date_at_from',
  'due_date_at_to',
];

const filterConfig: FilterFormConfig[] = [
  {
    type: 'date_range',
    field: 'created_at_from',
    fieldTo: 'created_at_to',
    label: 'common.created_at',
  },
  {
    type: 'date_range',
    field: 'due_date_at_from',
    fieldTo: 'due_date_at_to',
    label: 'common.due_date',
  },
  {
    type: 'search',
    field: 'search',
    label: 'Buscar por nombre',
  },
];

export interface PaymentLinkFiltersProps {
  filters: Metadata;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function PaymentLinkFilters({
  filters: _filters,
}: PaymentLinkFiltersProps): JSX.Element {
  return (
    <FilterControl
      defaultValues={DEFAULT_FILTER_VALUES}
      config={filterConfig}
      storageKey="pay_payment_links_filters"
      dateFields={DATE_FIELDS}
    />
  );
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function usePaymentLinkFilters<FilterType>() {
  return useUrlState<Partial<FilterType>>({}, DATE_FIELDS);
}
